module.exports = __webpack_public_path__ + "img/project_default.82a473f0.jpg";